import { useState, useEffect, useCallback, useMemo } from "react";
import { login as apiLogin, loginWithEntraToken as apiEntraLogin } from "../api/auth";

import { apiGet } from "../api/request";
export function useAuth() {
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("user");
    return stored ? JSON.parse(stored) : null;
  });

  useEffect(() => {
    if (token) {
      localStorage.setItem("token", token);
    } else {
      localStorage.removeItem("token");
    }
  }, [token]);

  const login = useCallback(async (email, password) => {
    const data = await apiLogin(email, password);
    setToken(data.access_token);
    localStorage.setItem("token", data.access_token);
    // Fetch user info after login
    const { default: api } = await import("../api/client");
    const me = await apiGet("/api/auth/me").then((r) => r.data);
    setUser(me);
    localStorage.setItem("user", JSON.stringify(me));
  }, []);

  const loginWithEntraToken = useCallback(async (idToken) => {
    const data = await apiEntraLogin(idToken);
    setToken(data.access_token);
    localStorage.setItem("token", data.access_token);
    const { default: api } = await import("../api/client");
    const me = await apiGet("/api/auth/me").then((r) => r.data);
    setUser(me);
    localStorage.setItem("user", JSON.stringify(me));
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    // Force navigation so protected routes re-evaluate auth state immediately.
    window.location.href = "/login";
  }, []);

  return useMemo(() => ({ token, user, login, loginWithEntraToken, logout }), [token, user, login, loginWithEntraToken, logout]);
}
